
<form [formGroup]="editForm">
<div class="edit-course-dialog">
  <div class="dialog-header">
    <h2>Edit 
		<ng-container *ngIf="data.label === 'Course' ">Course Title</ng-container>
		<ng-container *ngIf="data.label === _EditableStudyMaterialTypeEnum.Quiz && !data.showTimer "> Quiz Title</ng-container>
		<ng-container *ngIf="data.label === _EditableStudyMaterialTypeEnum.Quiz && data.showTimer "> Quiz Time</ng-container>	
	</h2>
    <span class="btn-close" (click)="onClose()"></span>
  </div>

  <div class="dialog-body">

	<ng-container *ngIf="!data.showTimer" >
		 <input
      type="text"
      formControlName="editTitle"
      class="course-title-input"
      placeholder="Enter {{ data.label }} Title"
    />
	</ng-container>

 <ng-container *ngIf="data.label === _EditableStudyMaterialTypeEnum.Quiz && data.showTimer">

    <label for="timeLimit">Time Limit</label>
    <div class="time-limit-section">
      <div class="time-inputs">
        <div class="time-field mb-2">
          <input type="number" min="0" placeholder="00" formControlName="hours" />
          <span>Hrs</span>
        </div>
        <div class="time-field mb-2">
          <input type="number" min="0" max="99" placeholder="00" formControlName="minutes" />
          <span>Min</span>
        </div>
        <div class="time-field mb-2">
          <input type="number" min="0" max="99" placeholder="00" formControlName="seconds" />
          <span>Sec</span>
        </div>
      </div>
    </div>
</ng-container>
  </div>

  <div class="dialog-footer">
    <button class="btn-signup" (click)="onEditTitle()" [disabled]="editForm.invalid">Save Changes</button>
  </div>
</div>
</form>